import { useMemo } from 'react';
import { detectRootCauses } from '../../../engine/incidentAI';

export function IncidentRootCause() {
  const anomalies = [{ ts:new Date().toISOString(), severity:3, deviceId:'m1' }];
  const suppliers = [{ id:'s1', rating:55 }, { id:'s2', rating:80 }];
  const causes = useMemo(()=> detectRootCauses({ anomalies, suppliers }), []);
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">Incident Root Cause (AI)</div>
      <ul className="list-disc ml-5 text-sm">
        {causes.map((c,i)=> (<li key={i}><span className="text-evat-neon">{c.label}</span> — score {c.score}</li>))}
      </ul>
    </div>
  );
}

export default IncidentRootCause;



















